export enum BcmTenantType {
    YachtHarbour = 'yacht_harbour',
    InlandPort = 'inland_port',
}
